import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { withNamespaces } from 'react-i18next';
import HRRequestHome from './HRRequestHome';
import HRRequestList from './HRRequestList';

function HRRequestTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

HRRequestTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function ScrollableTabsButtonForce({ t }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const requestClick = () => {
        setIndex(0);
    }

    const historyClick = () => {
        setIndex(1);
    }

    return (
        <React.Fragment>
            <div data-id="headerHRRequest" className={classes.root}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        <Tab className={"TabPageButton"} label={t('hrRequest:tabPanel.home')} {...a11yProps(0)} onClick={requestClick} />
                        <Tab className={"TabPageButton"} label={t('hrRequest:tabPanel.history')} {...a11yProps(1)} onClick={historyClick} />
                    </Tabs>
                </AppBar>
            </div>
            {index == 0 && <HRRequestHome />}
            {index == 1 && <HRRequestList />}
        </React.Fragment>
    );
}

export default withNamespaces(['hrRequest'], { wait: true })(ScrollableTabsButtonForce);
